// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { CategoryListResponse } from '@par/app/core/model/dictionaries.response';

export const getMediaGroupsListRequested = createAction('[SELECT MEDIA GROUPS] Get Media Groups Requested');
export const getMediaGroupsListSucceeded = createAction('[SELECT MEDIA GROUPS] Get Media Groups Succeeded', props<{
  response: string[]
}>());
export const getMediaGroupsListFailed = createAction('[SELECT MEDIA GROUPS] Get Media Groups Failed');
